import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';
import useStyles from './styles';

type Props = {
  open: boolean;
  onClose: () => void;
};

const PropertyInfoModalError = ({ open, onClose }: Props) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: classes.modalWrapper,
      }}
    >
      <Box className={classes.titleBox}>
        <ErrorOutlineIcon className={classes.titleIcon} />
        <Typography variant="h5" component="span" className={classes.titleText}>
          Accessibility Error
        </Typography>
      </Box>

      <DialogContent>
        <Box className={classes.contentBox}>
          <Typography
            variant="body1"
            className={classes.contentText}
          >
            This home can not be marked as
            <b> Accessible </b>
            because it has no attached device or hardware to enable tours.
          </Typography>

          <Typography
            variant="body2"
            component="div"
            className={classes.contactText}
          >
            Please contact
            <Link
              href="mailto:install@nternow.com"
              className={classes.contactLink}
            >
              install@nternow.com
            </Link>
            or
            <Link
              href="mailto:support@nternow.com"
              className={classes.contactLink}
            >
              support@nternow.com
            </Link>
            for help! We are here to support you.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions className={classes.actionsBox}>
        <Button
          onClick={() => onClose()}
          variant="contained"
          color="primary"
          fullWidth
          disableElevation
          className={classes.closeButton}
        >
          Understood
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(PropertyInfoModalError);
